import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
    private http = inject(HttpClient)
    private api = environment.apiBase

    // Replace with your actual API endpoint
    private readonly apiUrl = `${this.api}`;

    submitContactForm = (dto: Record<string, unknown>) =>
      this.http.post(`${this.apiUrl}/utility/contact-us`, dto)
    
}
